import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c26e2b20&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c26e2b20&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26e2b20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c26e2b20')) {
      api.createRecord('c26e2b20', component.options)
    } else {
      api.reload('c26e2b20', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c26e2b20&scoped=true", function () {
      api.rerender('c26e2b20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ik/table/input/IkTableImageOssTag/index.vue"
export default component.exports